import { useNavigate } from "react-router-dom";
import Auth from "../../services/Auth/Auth";
import ROLES from "../../utils/constants/roles.constants";
import AdminUserManual from "./AdminUserManual";
import DosenUserManual from "./DosenUserManual";
import MahasiswaUserManual from "./MahasiswaUserManual";

export default function UserManual() {
  const navigate = useNavigate();
  const user = Auth.getCurrentUser();
  return (
    <>
      <div className="mb-1 mx-4">
        <small>
          <span className="font-bold">Note: </span>Silakan{" "}
          <button
            className="text-blue-500 hover:underline"
            onClick={() => navigate(0)}
          >
            <i>refresh</i>
          </button>{" "}
          halaman ini jika <i>styling</i> kurang benar.
        </small>
      </div>
      <div className="m-4">
        <p className="mt-3">
          Sistem Informasi Penjadwalan Sidang (SISIDANG) merupakan sistem yang
          mengelola seluruh aktivitas sidang mahasiswa di setiap jenjang
          (S1/S2/S3). Aktivitas tersebut dimulai dari pengumpulan berkas sidang,
          persetujuan maju sidang, penjadwalan sidang, penilaian dan revisi,
          hingga pengumpulan berkas final. Adapun petunjuk penggunaan dari
          SISIDANG dapat dipelajari pada <i>user manual</i> berikut.
        </p>

        {user.role === ROLES.MAHASISWA && <MahasiswaUserManual />}
        {(user.role === ROLES.DOSEN || user.role === ROLES.DEVELOPER) && (
          <DosenUserManual />
        )}
        {(user.role === ROLES.ADMIN ||
          user.role === ROLES.MANAJER ||
          user.role === ROLES.STAFF ||
          user.role === ROLES.DEVELOPER) && <AdminUserManual />}
      </div>
    </>
  );
}
